import React from 'react';
import { insta } from '../../img';


const InstaFeedIntegration = ({
  createInstaFeedURL,
  instaFeedUser
}) => {
  return (
    <div className='card card-editor card-insta-connect'>
      <img className='insta-connect-img' src={insta} alt="Instagram" />
      {
        (instaFeedUser && instaFeedUser.itkn && instaFeedUser.itkn.length == 0) &&
        <button className='nf-btn nf-btn-default cnnct-insta-btn' onClick={() => createInstaFeedURL()}>Connect with Instagram</button>
      }
      {
        (instaFeedUser && instaFeedUser.itkn && instaFeedUser.itkn.length > 0) &&
        <div>
          <h6 className='insta-cnnct-txt'>Connected to <br />@{instaFeedUser.itkn[0].userName}</h6>
          <button className='btn upgrde-plan-cta' onClick={() => createInstaFeedURL()}>Change account</button>
        </div>
      }
    </div>
  );
};

export default InstaFeedIntegration;


// WEBPACK FOOTER //
// ./src/components/InstaFeedIntegration/InstaFeedIntegration.js